<template>
  <div>
    <!-- <v-container> -->
    <!-- <div>
      <date-filter
        @changeDate="getData"
        :defaultFilter="'last_15_days'"
        v-model="selectedDate"
      ></date-filter>
    </div> -->
    <!-- <div class="title mb-3">จำนวนผู้สมัคร</div> -->
    <Typography h2 bold label="จำนวนผู้สมัครเข้าร่วมโครงการ" />
    <v-layout row wrap class="mt-2">
      <v-flex xs12 sm12 style="display: flex; justify-content: space-between; align-items: center">
        <div style="display: flex; align-items: center; width: 60%">
          <multiselect
            v-model="filter.projectName"
            label="projectname"
            single-select
            placeholder="เลือกโครงการ"
            :options="projects"
            @input="onSearch"
          ></multiselect>
          <div class="ml-2 form-control" style="width: 55%">
            <date-picker
              range
              @input="onSearch"
              :shortcuts="shortcuts"
              :append-to-body="false"
              :clearable="false"
              :editable="false"
              input-class="dateSearch"
              name="DateSearch"
              v-model="selectedDate"
              valueType="date"
              format="DD/MM/YYYY"
              placeholder="Début - Fin"
            >
            </date-picker>
          </div>
        </div>

        <div>
          <v-btn
            variant="outlined"
            :v-tooltip="$t('export')"
            @click="modalExport = true"
            :loading="loading"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
          >
            <img
              src="/static/img/exportfilter.png"
              alt
              class="responsive-img"
              style="height: 16px"
            />
          </v-btn>
          <exportxlsx ref="exbtn" :value="exData" style="display: none"></exportxlsx>
        </div>
      </v-flex>
    </v-layout>
    <div class="text-xs-center pt-5" v-if="loading">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>
    <div v-else>
      <div v-if="data.length">
        <div class="text-xs-center mt-4 mb-3">
          <v-layout row wrap>
            <v-flex xs2></v-flex>
            <v-flex xs6>
              <apexchart
                class="mx-auto text-xs-center"
                :key="piechartkey"
                type="pie"
                width="550"
                :options="pieChartOptions"
                :series="pieSeries"
              ></apexchart>
            </v-flex>
            <v-flex xs4></v-flex>
          </v-layout>
        </div>
        <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="data"
          class="elevation-1"
          hide-actions
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left pa-3">
                <!-- {{ props.item.applicantstatus }} -->
                <Typography
                  :color="colorLabel(props.item.applicantstatus)"
                  h5
                  semiBold
                  :label="props.item.applicantstatus"
                />
              </td>

              <td class="text-xs-left pa-3" style="display: flex">
                <!-- {{ props.item.percent }} -->
                <Typography h5 semiBold :label="props.item.percent" />%
              </td>

              <td class="text-xs-left pa-3">
                <!-- {{ props.item.total }} -->
                <Typography h5 semiBold :label="props.item.total" />
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div v-else style="color: grey; font-size: 24px" class="mt-4 text-xs-center">ไม่พบข้อมูล</div>
    </div>
    <!-- </v-container> -->
     <v-dialog v-model="modalExport" persistent width="400px">
      <v-card style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <div></div>
            <div></div>

            <v-icon style="display: flex; align-items: center" @click="modalExport = false"
              >close</v-icon
            >
          </div>
          <div class="rsu">
            <v-layout column wrap justify-center align-center class="mb-3">
              <img
                src="/static/img/Export.png"
                alt
                class="responsive-img mb-1"
                style="height: 70px"
              />
              <Typography h2 bold label="ส่งออกข้อมูล" />
              <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
            </v-layout>
            <div class="text-xs-center">
              <div class="text-xs-center rsu">
                <v-btn
                  :loading="loading"
                  class="rsu"
                  round
                  small
                  outline
                  color="primary"
                  @click.stop="modalExport = false"
                  >ยกเลิก</v-btn
                >
                <v-btn
                  class="rsu"
                  :loading="loading"
                  round
                  small
                  depressed
                  style="color: #ffef01"
                  color="primary"
                  @click.stop="exportData"
                  >ยืนยัน</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import apexchart from 'vue-apexcharts'
import Typography from '@/components/elements/Typography.vue'
// import { VueDatePicker } from '@mathieustan/vue-datepicker'
import DatePicker from 'vue2-datepicker'
import Exportxlsx from '@/components/elements/exportxlsx'
export default {
  components: {
    DateFilter,
    Multiselect,
    apexchart,
    Typography,
    DatePicker,
    Exportxlsx,
  },
  data() {
    return {
      modalExport: false,
      exData: [],
      piechartkey: 0,
      pieSeries: [],
      currentDate: new Date(),
      pieChartOptions: {
        // colors: ['#1C64AF', '#B656C6', '#FFCD00', '#7DBDFF', '#FF9533'],
        chart: {
          width: 380,
          type: 'pie',
        },
        legend: {
          textAlign: 'left',
          // width: 200
        },
        textAlign: 'left',
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 400,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      loading: false,
      // selectedDate: {
      //   start: moment()
      //     .subtract(14, 'days')
      //     .format('YYYY-MM-DD 00:00'),
      //   end: moment().format('YYYY-MM-DD')
      // },
      selectedDate: [new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), new Date(new Date())],
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      total: 0,
      projects: [{ projectname: 'ทั้งหมด' }],
      filter: {
        projectName: { projectname: 'ทั้งหมด' },
      },
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    shortcuts() {
      const currentDate = new Date()
      const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)
      const fortyEightHoursAgo = new Date(Date.now() - 48 * 60 * 60 * 1000)
      const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
      return [
        {
          text: '24 ชั่วโมงที่แล้ว',
          onClick() {
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            const start = new Date(
              twentyFourHoursAgo.getFullYear(),
              twentyFourHoursAgo.getMonth(),
              twentyFourHoursAgo.getDate(),
              twentyFourHoursAgo.getHours(),
              twentyFourHoursAgo.getMinutes(),
              twentyFourHoursAgo.getSeconds()
            )

            const date = [start, end]
            return date
          },
        },
        {
          text: '48 ชั่วโมงที่แล้ว',
          onClick() {
            const start = new Date(
              fortyEightHoursAgo.getFullYear(),
              fortyEightHoursAgo.getMonth(),
              fortyEightHoursAgo.getDate(),
              fortyEightHoursAgo.getHours(),
              fortyEightHoursAgo.getMinutes(),
              fortyEightHoursAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )

            const date = [start, end]
            return date
          },
        },
        {
          text: 'อาทิตย์ที่แล้ว',
          onClick() {
            const start = new Date(
              oneWeekAgo.getFullYear(),
              oneWeekAgo.getMonth(),
              oneWeekAgo.getDate(),
              oneWeekAgo.getHours(),
              oneWeekAgo.getMinutes(),
              oneWeekAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: '15 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000)
            const end = new Date(currentDate)
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: 'เดือนที่แล้ว',
          onClick() {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
            const end = new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate()
            )
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: '365 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
            const end = new Date()
            // return a Date
            const date = [start, end]
            return date
          },
        },
      ]
    },
    headers() {
      return [
        {
          text: 'ประเภทสมาชิก',
          value: 'applicantstatus',
          align: 'left',
          width: '1%',
          sortable: false,
        },
        {
          text: 'เปอร์เซ็นต์',
          value: 'applicantstatus',
          align: 'left',
          width: '1%',
          sortable: false,
        },
        { text: 'จำนวน', value: 'total', align: 'left', width: '1%', sortable: false },
      ]
    },
  },
  async mounted() {
    await this.getProject()
    await this.getData()
  },
  methods: {
    async exportData() {
      this.loading = true
      await this.getData('export')
      this.loading = false
      this.$refs.exbtn.exportxlsx()
      this.modalExport = false
    },
    setupPieChart(data) {
      this.pieSeries = data.map((el) => parseInt(el.total))
      this.pieChartOptions.labels = data.map((el) =>
        el.applicantstatus ? el.applicantstatus : 'ไม่ระบุ'
      )
      this.pieChartOptions.colors = data.map((el) =>
        el.applicantstatus ? this.colorLabelGraph(el.applicantstatus) : 'ไม่ระบุ'
      )
      this.piechartkey++
    },
    getProject() {
      return new Promise((resolve) => {
        api.getdepaproject({}, (err, response) => {
          if (response.responsecode == 200) {
            this.projects = [...this.projects, ...response.data]
            resolve()
          }
        })
      })
    },
    onSearch() {
      this.getData()
    },
    colorLabel(name) {
      if (name === 'สมัครเข้าร่วมโครงการ') {
        return 'color-darkBlue2'
      } else if (name === 'รอการพิจารณา') {
        return 'color-lightPurple'
      } else if (name === 'waiting list') {
        return 'color-lightYellow2'
      } else if (name === 'อนุมัติการสมัครเข้าร่วมโครงการ') {
        return 'color-lightBlue'
      } else if (name === 'ไม่อนุมัติการสมัครเข้าร่วมโครงการ') {
        return 'color-lightOrange'
      } else {
        return 'color-mediumGrey'
      }
    },
    colorLabelGraph(name) {
      if (name === 'สมัครเข้าร่วมโครงการ') {
        return '#1C64AF'
      } else if (name === 'รอการพิจารณา') {
        return '#B656C6'
      } else if (name === 'waiting list') {
        return '#FFCD00'
      } else if (name === 'อนุมัติการสมัครเข้าร่วมโครงการ') {
        return '#7DBDFF'
      } else if (name === 'ไม่อนุมัติการสมัครเข้าร่วมโครงการ') {
        return '#FF9533'
      } else {
        return '#818181'
      }
    },
    getData(type) {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate[0]).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate[1]).format('YYYY-MM-DD'), // YYYY-MM-DD
        }

        if (this.filter.projectName && this.filter.projectName.projectname !== 'ทั้งหมด') {
          Object.assign(data, { projectName: this.filter.projectName.projectname })
        }
        this.loading = true
        api['depausersapplyprojectapplicantsbystatus'](data, async (err, response) => {
          this.loading = false
          this.setupPieChart(response.data)
          const total = this.pieSeries.reduce((a, b) => a + b, 0)
          const percent = this.pieSeries.map((value) => (value / total) * 100)

          this.data = response.data.map((item, index) => {
            return {
              applicantstatus: item.applicantstatus,
              total: item.total,
              path: item.path,
              percent: percent[index].toFixed(1),
            }
          })
          if(type === 'export'){
            await this.setEx(this.data) 
          }

          if (response.total) {
            this.total = response.total
          } else {
            this.total = 0
          }
          resolve()
        })
      })
    },
    setEx(data) {
      if (data) {
        let ex = []
        data.forEach((ele) => {
          let obj = {
            ประเภทสมาชิก: ele.applicantstatus,
            เปอร์เซ็นต์: ele.percent,
            จำนวน: ele.total,
          }
          ex.push(obj)
        })
        this.exData = ex
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/Depausersapplyprojectapplicantsbystatus.vue